import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mfp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Offline: keep pages in loading state instead of showing misleading empty data
    if (!err.response && !navigator.onLine) return new Promise(() => {});
    if (err.response?.status === 401) {
      localStorage.removeItem("mfp_token");
      localStorage.removeItem("mfp_user");
      if (!window.location.pathname.startsWith("/login") && !window.location.pathname.startsWith("/register") && window.location.pathname !== "/") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
